/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import React, {PureComponent} from 'react';
import {AppContext} from "../../misc/appContext";
import FirstImport from "./firstImport";

interface State {
    position: { x: number, y: number };
    active: boolean;
}

export default class FirstImportController extends PureComponent {
    declare context: React.ContextType<typeof AppContext>;
    static contextType = AppContext;
    state: State = {
        position: {x: 0, y: 0},
        active: false
    };

    onActivate = () => {
        const orderElement = document.querySelector('div.first-order');
        if (!orderElement) return;
        const box = orderElement.getBoundingClientRect();
        this.setState({position: {x: box.x, y: box.y}}, () => {
            this.setState({active: true});
        });
        this.updateUser();
    };

    onClose = () => {
        this.setState({active: false}, () => {
            this.setState({position: {x: 0, y: 0}});
        })
    };

    updateUser = () => {
        const {user} = this.context.userContext;
        if (!user) return;
        user.setFlex('has_imported_old_order', true);
        user.update();
    };

    render = () => {
        const {active, position} = this.state;
        return (
            <FirstImport onClose={this.onClose} active={active} position={position}/>
        );
    }
}